import { render, staticRenderFns } from "./DefaultBox.vue?vue&type=template&id=09ca2a63"
import script from "./DefaultBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports